import { UIHeading2, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'clsx';
import { IOfferCardProps, OfferCard } from '../OfferCard';
import { MultiOfferContainer } from 'shared/containers/MultiOfferContainer';
import { EMappedTypeOffer } from '../../constants/mapOfferTypes';
import styles from './styles.css';
import { FillApplicationButton } from '../../containers/stickyButtons/FillApplicationButton';
import { EFillApplicationStickyButtonType } from '../../containers/stickyButtons/FillApplicationButton/types';
import { ETestIds } from '../../constants/testIds';
import { TMapOffersResult } from '../../types/common/offer';
import { useIsDesktop } from '../../hooks/common';
import { RefinBannerContainer } from 'shared/containers/RefinBannerContainer';

export interface IOfferListProps {
  offersList: TMapOffersResult;
}

type TMapComponents = Record<
  EMappedTypeOffer,
  (props: IOfferCardProps | IOfferCardProps[]) => React.ReactElement | null
>;

const mapComponents: TMapComponents = {
  offer: (props: IOfferCardProps) => <OfferCard {...props} />,
  multi: (props: IOfferCardProps[]) => <MultiOfferContainer multiOffers={props} />,
};

const BANNER_CARD_INDEX_DESKTOP = 2;
const BANNER_CARD_INDEX_MOBILE = 1;

export const OfferList: React.FC<IOfferListProps> = ({ offersList }) => {
  const deviceType = useDeviceType();
  const isDesktop = useIsDesktop();

  const bannerCardIndex = isDesktop ? BANNER_CARD_INDEX_DESKTOP : BANNER_CARD_INDEX_MOBILE;

  return (
    <div className={cn(styles['container'], styles[deviceType])} data-testid={ETestIds.OfferListContainer}>
      {!isDesktop && (
        <div className={cn(styles['title'])} data-testid={ETestIds.OfferListTitle}>
          <UIHeading2>Ваши предложения</UIHeading2>
        </div>
      )}
      <ul className={cn(styles['list'], styles[deviceType])} data-testid={ETestIds.OfferList}>
        {offersList.slice(0, bannerCardIndex).map(({ type, content }, index) => {
          return <li key={index}>{mapComponents[type](content)}</li>;
        })}
        <RefinBannerContainer />
        {offersList.slice(bannerCardIndex).map(({ type, content }, index) => {
          return <li key={index}>{mapComponents[type](content)}</li>;
        })}
      </ul>
      {isDesktop && <FillApplicationButton currentButtonType={EFillApplicationStickyButtonType.TOP} />}
    </div>
  );
};
